// src/utils/cookieConsentConfig.ts
import type { CookieConsentConfig } from 'vanilla-cookieconsent';

export const config: CookieConsentConfig = {
  guiOptions: {
    consentModal: {
      layout: "box",
      position: "bottom left",
      equalWeightButtons: true,
      flipButtons: false,
    },
    preferencesModal: {
      layout: "box",
      position: "right",
      equalWeightButtons: true,
      flipButtons: false,
    },
  },
  categories: {
    necessary: {
      readOnly: true,
      enabled: true
    },
    analytics: {
      autoClear: {
        cookies: [
          {
            name: /^(_ga|_gid)/,
          },
        ],
      },
    },
  },
  language: {
    default: "fr",
    autoDetect: "browser",
    translations: {
      fr: {
        consentModal: {
          title: "On doit parler de vos données",
          description:
            "Nous utilisons des cookies pour analyser le trafic et améliorer l'expérience. Vous pouvez décider quels cookies vous autorisez.",
          acceptAllBtn: "Tout accepter",
          acceptNecessaryBtn: "Tout refuser",
          showPreferencesBtn: "Gérer mes préférences",
        },
        preferencesModal: {
          title: "Préférences de confidentialité",
          acceptAllBtn: "Tout accepter",
          acceptNecessaryBtn: "Tout refuser",
          savePreferencesBtn: "Sauvegarder",
          closeIconLabel: "Fermer",
          sections: [
            {
              title: "Cookies strictement nécessaires",
              description:
                "Ces cookies sont essentiels au fonctionnement du site (sécurité, connexion).",
              linkedCategory: "necessary",
            },
            {
              title: "Analytique & Performance",
              description:
                "Ces cookies nous permettent de compter les visites et les sources de trafic (Google Analytics).",
              linkedCategory: "analytics",
            },
          ],
        },
      },
    },
  },
};